













import Vue from 'vue'
import { Stay } from 'models/data/stay'
import stays from '@store/stays'
import { readyWhen } from 'utils/text/plan'
import EditModal from '../EditModal.vue'
import EditReadyWhen from '@ward/discharge/EditReadyWhen.vue'


export default Vue.extend({
    components: {
        EditModal,
        EditReadyWhen,
    },
    props: {
        stay_id: {
            type: Number,
            required: true
        }
    },
    computed: {
        stay(): Stay | undefined {
            return stays.state.stays[this.stay_id]
        },
        summaryText(): string[] {
            return readyWhen({ stay: this.stay })
        },
    },
})
